import { isBefore, add, format } from "date-fns";
import React from "react";
import { Meeting } from "src/models";
import { Text, Tooltip } from "src/components";
import { getDateDiff, startOf } from "src/util/util";
import { useTranslation } from "react-i18next";
import { StickyTableCell } from "../components/stickyTableCell";
import { TableDataCounter } from "../components/tableDataCounter";


export interface IMeetingRowProps {
  meetings:   Meeting[],
  view:       "days" | "weeks" | "months",
  start:      Date,
  end:        Date,
}

export const MeetingRow = (props: IMeetingRowProps) => {
  const { meetings, view, start, end } = props;
  const { t, i18n } = useTranslation();

  const cells = [];
  const _meetings: Meeting[] = (meetings || []).slice();
  _meetings.sort((m1: Meeting, m2: Meeting) => m1.date.getTime() - m2.date.getTime());

  for (let curDate = startOf(start, view); isBefore(curDate, end); curDate = add(curDate, { [view]: 1 })) {
    const m: Meeting[] = [];
    while (_meetings.length && getDateDiff(_meetings[0].date, curDate, view) < 1) 
      m.push(_meetings.shift());
      
    cells.push(
      <td key={curDate.toString() + "meetings"} style={{height: '1.5rem'}}>
        {  m.length > 0 && (
           <Tooltip
            placement = "left"
            content   = {m.map( i => (<p style={{marginBottom: '0.5rem'}}>{`${format(i.date, "yyyy-MM-dd")} - ${i.title}`}</p>))}
          >
          <TableDataCounter variant="meeting">
            <span>{m.length}</span>
          </TableDataCounter>
          </Tooltip>
          )
        }
      </td>
    );
  }
  

  return (
    <>
      <StickyTableCell>
        <Text as="p" size="default" weight="bold" color="grayDark">
        {t("meeting_plural")}
        </Text>
        </StickyTableCell>
      {cells}
    </>
  );
}
